/**
 * Links from a project's Billing panel into the New invoice / New quote pages.
 * The project and its client travel in the query string so a reload keeps them
 * and the link can be shared; the form reads them back with `readBillingPrefill`.
 */
export interface BillingPrefill {
  projectId: string;
  clientId: string;
}

export function newBillingDocPath(base: string, prefill: { projectId?: string | null; clientId?: string | null }): string {
  const params = new URLSearchParams();
  if (prefill.projectId) params.set('project_id', prefill.projectId);
  if (prefill.clientId) params.set('client_id', prefill.clientId);
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

export function readBillingPrefill(search: string): BillingPrefill {
  const params = new URLSearchParams(search);
  return { projectId: params.get('project_id') ?? '', clientId: params.get('client_id') ?? '' };
}
